import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setLocation } from 'src/app/redux/actions/options.action';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { MaestrosService } from 'src/app/shared/services/mestros.service';
import { SessionChecker } from 'src/app/shared/session.checker';
import { TablesIBMClass } from 'src/app/shared/tables-ibm';

@Component({
  selector: 'app-generate-order',
  templateUrl: './generate-manual-order.component.html',
  styleUrls: ['./../../shared/styles/body.scss']
})
export class GenerateManualOrderComponent extends TablesIBMClass implements OnInit, OnDestroy {
  public isLoading:boolean=false;
  private load$!:Subscription;  

  constructor(private store: Store<appState>, private checker:SessionChecker, maestroSvc:MaestrosService) {
    super(maestroSvc);
    this.checker.rememberAndActualizateUser(this.store);
    this.store.dispatch(setLocation({location: NAVEGATION.GENERATE_MANUAL_ORDER}));

    this.load$=this.store.select('options', 'modalCreate', 'isLoading').subscribe( (isLoading:boolean) => {
      this.isLoading = isLoading;
    });
  }

  ngOnInit(): void {
    this.checkTables();
  }

  ngOnDestroy(): void {
    this.load$?.unsubscribe();
  }
}